import React from 'react';
import { FormattedMessage } from 'react-intl';

class LimitedAccessUser extends React.Component {

    render() {
        return (
            <div className="limited-access-user-dashboard">
                <div className='no-entities-message'>
                    <FormattedMessage id='General_CoreFunctionality_UIText_general.contactAdministrator' />
                </div>
            </div>
        );
    }
}

export default LimitedAccessUser;


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/LimitedAccessUser/LimitedAccessUser.jsx